import { v4 as uuidv4 } from 'uuid';
import { format } from 'date-fns';
import api from '../apis/constants';
import {
    Order,
    OrderStatus,
    OrderStatusLog,
    OrderFilter,
    ShippingInfo,
    PaymentInfo,
    OrderItem,
    OrdersResponse
} from '../types/orders';
import { orderApi } from '../apis/order';
import { OrderStats } from '../types/orderStats';
import { GetOrdersStatsResponse } from '../apis/admin';

const orderService = {
    // Lấy danh sách đơn hàng với các tham số lọc
    async getOrders(filter?: OrderFilter): Promise<OrdersResponse> {
        const response = await orderApi.getOrders(filter);
        return response;
    },

    async getOrdersExport(filter?: OrderFilter): Promise<any> {
        console.log('filter', filter)
        const response = await orderApi.getReportOrders(filter);

        if (response.data) {
            return {
                data: response.data,
                total: response.total
            }
        }

        return {
            total: [],
            data: []
        };
    },

    // Lấy chi tiết một đơn hàng
    async getOrderById(id: string): Promise<any> {
        try {
            return {}
        } catch (error) {
            throw new Error('Không tìm thấy đơn hàng');
        }
    },

    // Lấy lịch sử trạng thái đơn hàng
    async getOrderStatusLogs(orderId: string): Promise<any> {
        try {
            return []
        } catch (error) {
            console.error('Error fetching order status logs:', error);
            return [];
        }
    },

    // Cập nhật trạng thái đơn hàng
    async updateStatus(orderId: string, newStatus: OrderStatus, additionalData?: any) {
        let data = {}
        if (newStatus === 'pending') {
            data = {
                "status": newStatus,
                "note": "Đơn hàng đang chờ xử lý"
            }
        } else if (newStatus === 'processing') {
            data = {
                "status": newStatus,
                "note": "Xác nhận đơn hàng"
            }
        } else if (newStatus === 'shipped') {
            data = {
                "status": newStatus,
                "shipping_fee": additionalData?.shippingFee,
                "note": "Đã giao hàng"
            }
        } else if (newStatus === 'delivered') {
            data = {
                "status": newStatus,
                "note": "Hoàn thành"
            }
        } else if (newStatus === 'cancelled') {
            data = {
                "status": newStatus,
                "reason": additionalData?.reason,
                "surcharge": additionalData?.surcharge,
                "note": additionalData?.reason
            }
        } else if (newStatus === 'rejected') {
            data = {
                "status": newStatus,
                "reason": additionalData?.reason,
                "surcharge": additionalData?.surcharge,
                "note": additionalData?.reason
            }
        }

        const response = await orderApi.updateStatus(orderId, data)

        if (response) {
            return response
        } else {
            throw new Error('Cập nhật trạng thái đơn hàng thất bại')
        }
    },

    // Cập nhật thông tin vận chuyển
    async updateShippingInfo(orderId: string, shippingInfo: Partial<ShippingInfo>): Promise<any> {
        try {
            return {}
        } catch (error) {
            throw new Error('Không thể cập nhật thông tin vận chuyển');
        }
    },

    // Cập nhật thông tin thanh toán
    async updatePaymentInfo(orderId: string, paymentInfo: Partial<PaymentInfo>): Promise<any> {
        try {
            return {}
        } catch (error) {
            throw new Error('Không thể cập nhật thông tin thanh toán');
        }
    },

    // Thống kê đơn hàng theo trạng thái
    async getOrderStats(branchId?: string): Promise<Record<OrderStatus, number>> {
        try {
            const response = await api.get<OrderStats>(branchId ? `/manager/order-stats?branch_id=${branchId}` : `/manager/order-stats`);
            return response.data.byStatus;
        } catch (error) {

            return {
                pending: 0,
                processing: 0,
                shipped: 0,
                delivered: 0,
                cancelled: 0,
                rejected: 0,
            };
        }
    },

    async getOrderStatsByType(branchId?: string, startDate?: string, endDate?: string): Promise<GetOrdersStatsResponse> {
        try {
            let url = branchId 
                ? `/manager/orders-type-stats?branch_id=${branchId}` 
                : '/manager/orders-type-stats';
            
            if (startDate) {
                url += `&start_date=${startDate}`;
            }
            if (endDate) {
                url += `&end_date=${endDate}`;
            }

            const response = await api.get<GetOrdersStatsResponse>(url);
            return response.data;
        } catch (error) {
            console.error('Error fetching order stats by type:', error);
            throw error;
        }
    },

    // Cập nhật ghi chú đơn hàng
    async updateOrderNotes(orderId: string, notes: string): Promise<Order> {
        try {
            const response = await orderApi.updateOrderNotes(orderId, notes);
            return response;
        } catch (error) {
            throw new Error('Không thể cập nhật ghi chú đơn hàng');
        }
    },
};

export default orderService; 